// extracted by mini-css-extract-plugin
module.exports = {"dot":"Badge_dot__11wsR","badge":"Badge_badge__2hY37"};